<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-classevaluate__examineitem">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
<!--        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('classEvaluate:examineItem:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('classEvaluate:examineItem:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="examineItemName" label="检查项名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="examineTypeName" label="检查类型名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="score" label="分数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('classEvaluate:examineItem:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('classEvaluate:examineItem:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
              <el-button v-if="$hasPermission('classEvaluate:examineItem:config')" type="text" size="small"
                         @click="evaluateItemConfig(scope.row)">
                  评分项设置
              </el-button>
              <el-button v-if="$hasPermission('classEvaluate:evaluateRemark:config')" type="text" size="small"
                         @click="evaluateRemarkConfig(scope.row)">
                  备注设置
              </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <!--评分项设置-->
      <evaluate-item v-if="evaluateItemVisible" ref="evaluateItem" @refreshDataList="getDataList()"></evaluate-item>
        <!--备注项设置-->
      <evaluate-remark v-if="evaluateRemarkVisible" ref="evaluateRemark" @refreshDataList="getDataList()"></evaluate-remark>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './examineitem-add-or-update'
import EvaluateItem from './evaluateitem.vue'
import EvaluateRemark from './evaluateremark.vue'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/classEvaluate/examineItem/page',
        getDataListIsPage: true,
        exportURL: '/classEvaluate/examineItem/export',
        deleteURL: '/classEvaluate/examineItem',
        deleteIsBatch: true
      },
      evaluateRemarkVisible: false,
      evaluateItemVisible: false,
      dataForm: {
        id: ''
      }
    }
  },
  methods: {
    evaluateItemConfig (row) {
      console.log(row)
      this.evaluateItemVisible = true
      this.$nextTick(() => {
        this.$refs.evaluateItem.dataForm.examineItemId = row.id
        this.$refs.evaluateItem.init()
      })
    },
    evaluateRemarkConfig (row) {
      this.evaluateRemarkVisible = true
      this.$nextTick(() => {
        this.$refs.evaluateRemark.dataForm.examineItemId = row.id
        this.$refs.evaluateRemark.init()
      })
    }
  },
  watch: {
  },
  components: {
    EvaluateRemark,
    AddOrUpdate,
    EvaluateItem
  }
}
</script>
